export default {
  promo: {
    metrics: {
      description_1: 'Effizienz der Empfehlungen',
      description_2: 'Geschwindigkeit der Architektur',
      description_3: 'Tiefe der Visualisierung'
    }
  }
}
